export enum PaymentMethodsStatus {
  UNKNOWN = 'unknown',
  MISSING = 'missing',
  READY = 'ready'
}
